import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Button } from 'reactstrap';
import { Modal } from 'react-responsive-modal';
import {
  addLeavePolicy,
  getMember,
  getLeavePolicyByID,
  updateLeavePolicy,
} from '../../../redux/MainAction';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const AddpolicyModal = ({ open, onClose, editID }) => {
  const dispatch = useDispatch();
  const tmlist = useSelector((state) => state.Webtracker.member);
  const single = useSelector((state) => state.Webtracker.leavePolicyByID);

  const [empDataOption, setEmpDataOption] = useState([]);
  const [empDataValue, setEmpDataValue] = useState([]);

  const [switch2, setSwitch2] = useState(false);

  const handleSwitchChange1 = () => {
    setSwitch2(!switch2);
  };
  const [switch3, setSwitch3] = useState(false);

  const handleSwitchChange2 = () => {
    setSwitch3(!switch3);
  };

  const [addData, setAddData] = useState({
    timeUnit: 'DAYS',
    name: '',
    payment: 'UNPAID',
    reason: 'REQUIRED',
    duration: '',
    workingHoursPerDay: '',
  });

  useEffect(() => {
    if (editID) getList();
  }, [editID]);

  const getList = () => {
    if (editID) {
      var pay = {
        id: editID,
      };
      dispatch(getLeavePolicyByID(pay));
    }
  };

  useEffect(() => {
    if (!tmlist || !Array.isArray(tmlist?.rows)) {
      var data = {
        offset: 0,
        limit: 10,
      };
      dispatch(getMember(data));
    }
  }, [tmlist]);

  const onChangeData = (e) => {
    const { name, value } = e.target;
    setAddData({ ...addData, [name]: value });
  };
  useEffect(() => {
    if (tmlist && tmlist?.rows) {
      const option = tmlist?.rows?.map((user) => {
        return {
          label: `${user?.firstName} ${user?.lastName}`,
          value: user?.id,
        };
      });
      setEmpDataOption(option);
    }
  }, [tmlist]);
  console.log('editID', editID);

  const onEmployeeChange = (value) => {
    if (value) {
      setEmpDataValue(value);
    }
  };

  useEffect(() => {
    if (editID) {
      console.log('True', editID);

      setAddData({
        timeUnit: single?.timeUnit,
        name: single?.name,
        payment: single?.payment,
        reason: single?.reason,
        duration: single?.duration,
        workingHoursPerDay: single?.workingHoursPerDay,
      });
      setSwitch2(single?.isApplicableToNewEmployees);
      setSwitch3(single?.isNegativeBalanceAllowed);
      const option = single?.leavePolicyMembers?.map((user) => {
        return {
          label: `${user?.employee?.firstName} ${user?.employee?.lastName}`,
          value: user?.employeeId,
        };
      });
      setEmpDataValue(option);
    } else {
      setAddData({
        timeUnit: 'DAYS',
        name: '',
        payment: 'UNPAID',
        reason: 'REQUIRED',
        duration: '',
        workingHoursPerDay: '0',
      });
      setSwitch2(false);
      setSwitch3(false);
      setEmpDataValue([]);
    }
  }, [single, editID]);

  const onSaveHandle = (e) => {
    e.preventDefault();

    const pay = {
      name: addData?.name,
      isApplicableToNewEmployees: switch2,
      isNegativeBalanceAllowed: switch3,
      reason: addData?.reason,
    };

    if (addData?.timeUnit !== '') {
      pay.timeUnit = addData?.timeUnit;
    }
    if (addData?.payment !== '' && addData?.payment !== null) {
      pay.payment = addData?.payment;
    }
    if (
      addData?.workingHoursPerDay !== '' &&
      addData?.workingHoursPerDay !== null
    ) {
      pay.workingHoursPerDay = addData?.workingHoursPerDay;
    }
    if (addData?.duration !== '' && addData?.duration !== null) {
      pay.duration = addData?.duration;
    }

    if (!editID) {
      if (addData?.name === '') {
        toast.error('Please Add policy name !', {
          position: 'top-right',
        });
        return false;
      }

      const empV = empDataValue?.map((itm) => itm.value);

      console.log('Add', { ...pay, employeeIds: empV });

      dispatch(addLeavePolicy({ ...pay, employeeIds: empV }));
      onClose();

      setAddData({
        timeUnit: 'DAYS',
        name: '',
        payment: 'UNPAID',
        reason: 'REQUIRED',
      });
      setEmpDataValue([]);
    } else {
      console.log('Updated');
      const empV = empDataValue?.map((itm) => itm.value);
      // console.log('Edit',payloadID);
      dispatch(updateLeavePolicy({ ...pay, employeeIds: empV, id: editID }));
      onClose();
    }
  };
  console.log('single', single);
  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      classNames={{ modal: 'custom-modal' }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h5>{!editID ? 'New' : 'Update'} Policy</h5>
        <i
          onClick={onClose}
          className="fa fa-times font-20"
          style={{ cursor: 'pointer' }}
        ></i>
      </div>
      <div className="tab-content">
        <div className="row col-12">
          <div className="form-group col-6">
            <label for="username1" className="font-14 text-muted ">
              Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Name"
              className="form-control"
              name="name"
              value={addData?.name}
              onChange={onChangeData}
              id="username1"
            />
          </div>
          <div className="form-group col-6">
            <label className="text-muted">Time</label>
            <div className="">
              <select
                className="form-control"
                name="timeUnit"
                value={addData?.timeUnit}
                onChange={onChangeData}
              >
                <option>Select Time</option>
                <option value="HOURS">HOURS</option>
                <option value="DAYS">DAYS</option>
              </select>
            </div>
          </div>
        </div>
        <div
          className=" form-group"
          style={{ marginLeft: '10px', width: '520px' }}
        >
          <label className="control-label">Select Employee</label>
          <Select
            value={empDataValue}
            onChange={onEmployeeChange}
            options={empDataOption}
            isMulti={true}
          />
        </div>
        <div className="row col-12">
          <div className="form-group col-6">
            <label className="text-muted">Policy type</label>
            <div className="">
              <select
                className="form-control"
                name="payment"
                value={addData?.payment}
                onChange={onChangeData}
              >
                {/* <option>Select Type</option> */}
                <option value="UNPAID">UNPAID</option>
                <option value="PAID">PAID</option>
              </select>
            </div>
          </div>
          <div className="form-group col-6">
            <label className="text-muted">Reason</label>
            <div className="">
              <select
                className="form-control"
                name="reason"
                value={addData?.reason}
                onChange={onChangeData}
              >
                {/* <option>Select Reason</option> */}
                <option value="REQUIRED">REQUIRED</option>
                <option value="OPTIONAL">OPTIONAL</option>
              </select>
            </div>
          </div>
        </div>

        <div className="row col-12">
          <div className="form-group col-6">
            <label for="username1" className="font-14 text-muted ">
              Duration
            </label>
            <input
              type="number"
              placeholder="Ex. 1"
              className="form-control"
              name="duration"
              value={addData?.duration}
              onChange={onChangeData}
              id="username1"
            />
          </div>
          <div className="form-group col-6">
            <label for="username1" className="font-14 text-muted ">
              Working Hours Per Day{' '}
            </label>
            <input
              type="number"
              placeholder="Ex. 1"
              className="form-control"
              name="workingHoursPerDay"
              value={addData?.workingHoursPerDay}
              onChange={onChangeData}
              id="username1"
            />
          </div>
        </div>

        <div className="d-flex justify-content-start ml-2">
          <div className="">
            <input
              type="checkbox"
              id="switch_6"
              switch="primary"
              checked={switch2}
              onChange={handleSwitchChange1}
            />
            <label
              htmlFor="switch_6"
              data-on-label=""
              data-off-label=""
            ></label>
          </div>
          <span
            className="ml-4 font-16 "
            style={{ cursor: 'pointer' }}
            onClick={handleSwitchChange1}
          >
            Applicable To New Employees
          </span>
        </div>
        <div className="d-flex justify-content-start ml-2">
          <div className="">
            <input
              type="checkbox"
              id="switch_65"
              switch="primary"
              checked={switch3}
              onChange={handleSwitchChange2}
            />
            <label
              htmlFor="switch_65"
              data-on-label=""
              data-off-label=""
            ></label>
          </div>
          <span
            className="ml-4 font-16 "
            style={{ cursor: 'pointer' }}
            onClick={handleSwitchChange2}
          >
            Negative Balance Allowed
          </span>
        </div>
      </div>
      <div className="modal-footer">
        <Button size="sm" className="btn btn-light" onClick={onClose}>
          Cancel
        </Button>
        <Button size="sm" className="btn btn-primary" onClick={onSaveHandle}>
          {' '}
          {!editID ? 'Create' : 'Update'} Policy
        </Button>
      </div>
    </Modal>
  );
};

export default AddpolicyModal;
